import { ReactElement, ReactNode, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { userStore } from 'store/user';
import { ROLE_TYPE } from 'types/enumType';
import { decryptString } from 'util/encryptUtil';

interface AuthGuardProps {
  children: ReactNode;
}

const getNavigateAfterCheckLogin = (
  url: string,
  isAuthenticated: boolean,
): ReactElement | null => {
  if (isAuthenticated) {
    if (url === '/sign-in' || url === '/') {
      return <Navigate to={'/log'} replace />;
    }
  } else {
    if (!(url === '/sign-in')) {
      return <Navigate to={'/sign-in'} />;
    }

    return null;
  }

  return null;
};

const getNavigateAfterCheckAuthority = (
  url: string,
  role: string,
): ReactElement | null => {
  if (
    (url.startsWith('/inquiry') ||
      url.startsWith('/user') ||
      url.startsWith('/locker')) &&
    role !== ROLE_TYPE.ADMIN
  ) {
    alert('접근 권한이 없습니다.');
    return <Navigate to={'/log'} replace />;
  }

  return null;
};

const AuthGuard = ({ children }: AuthGuardProps) => {
  const userRole = userStore((state) => state.role);
  const userIsAuthenticated = userStore((state) => state.isAuthenticated);
  const location = useLocation();
  const role = decryptString(userRole ?? '');
  const url = location.pathname;

  if (!role) {
    alert('권한에 변경이 생거 로그아웃 됩니다.\n다시 로그인 해주세요');
    sessionStorage.clear();
    return <Navigate to={'/sign-in'} />;
  }

  const navigateElement =
    getNavigateAfterCheckLogin(url, userIsAuthenticated) ||
    getNavigateAfterCheckAuthority(url, role);
  if (navigateElement) {
    return navigateElement;
  }

  return <Suspense>{children}</Suspense>;
};

export default AuthGuard;
